module.exports = __webpack_public_path__ + "img/shop_bg.42df6724.png";